import React from 'react';

//styling

// constants
import {
  BACK, BALANCE_SHEET_PAGES, INCOME_CURRENCY_OPTIONS,
  INCOME_SOURCE_OPTIONS,
} from './constants';

import TopToolbar from '../../global/subcomponents/topToolbar/TopToolbar';

import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { Divider, Checkbox, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SaveIcon from '@material-ui/icons/Save';
import { Chip, IconButton } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import MenuIcon from '@mui/icons-material/Menu';

class BalanceSheetSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      category: [],
      requiredList: ['name','category'],
      templates: this.props.templates || [],
      open: false,
      anchorEl: null,
      activeIndex: null,
      draggedIndex: null,
      draggedSection: null,
    };
  }

  componentDidMount() {
    if (this.props.templates && this.props.templates.length > 0) {
      this.setState({ templates: [...this.props.templates] });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.templates !== this.props.templates ||
      nextState.templates !== this.state.templates ||
      nextState.anchorEl !== this.state.anchorEl ||
      nextState.activeIndex !== this.state.activeIndex ||
      nextState.draggedIndex !== this.state.draggedIndex
    );
  }

  onDragStart = (index, sectionName) => {
    this.setState({ draggedIndex: index, draggedSection: sectionName });
  };

  onDragOver = (hoverIndex, sectionName) => {
    const { draggedIndex, draggedSection, templates } = this.state;

    // Only reorder within the same section
    if (draggedIndex === null || draggedSection !== sectionName) return;

    // Filter out the section templates based on sectionName
    const sectionTemplates = templates.filter(t => t.section === sectionName);

    // Map the section templates to their respective global indices
    const sectionIndices = sectionTemplates.map((t, index) => {
      const globalIndex = templates.findIndex(item => item === t);
      return { ...t, index: globalIndex };
    });

    // Get the global index for the dragged item and the hover item
    const dragGlobalIndex = sectionIndices[draggedIndex].index;
    const hoverGlobalIndex = sectionIndices[hoverIndex].index;

    // Only proceed if the hover index is different from the dragged index
    if (dragGlobalIndex === hoverGlobalIndex) return;

    const updatedTemplates = [...templates];

    // Remove the dragged item from its current position
    const [draggedItem] = updatedTemplates.splice(dragGlobalIndex, 1);

    // Insert the dragged item at the hover position
    updatedTemplates.splice(hoverGlobalIndex, 0, draggedItem);

    // Update state with the new templates order
    this.setState({
      templates: updatedTemplates,
      draggedIndex: hoverIndex,
    });
  };

  onDragEnd = () => {
    this.setState({ draggedIndex: null, draggedSection: null });
  };

  handleChange = (state) => {
    this.setState(state);
  };

  getSectionIndex = (templates, sectionName, currentIndex) => {
    let count = -1;
    for (let i = 0; i <= currentIndex; i++) {
      if (templates[i].section === sectionName) {
        count++;
      }
    }
    return count;
  };

  handleTemplateChange = (e, index, sectionName) => {
    const { name, value } = e.target;

    this.setState((prevState) => {
      const updatedTemplates = prevState.templates.map((template, i) => {
        // Only update the matching index within the correct section
        if (template.section === sectionName && index === this.getSectionIndex(prevState.templates, sectionName, i)) {
          return {
            ...template,
            [name]: value,
          };
        }
        return template;
      });

      return { templates: updatedTemplates };
    });
  };

  removeTemplateRow = (index, sectionName) => {
    this.setState((prevState) => {
      const sectionTemplates = prevState.templates.filter(template => template.section === sectionName);

      const updatedTemplates = prevState.templates.filter((template, curIndex) => {
        if (template.section === sectionName) {
          const sectionIndex = sectionTemplates.findIndex(t => t === template);
          return sectionIndex !== index;
        }
        return true;
      });
      return { templates: updatedTemplates };
    });
  };


  addTemplateRow = (section) => {
    this.setState((prevState) => {
      const updatedTemplates = [
        ...prevState.templates,
        {
          name: '',
          section: section,
          source: '',
          category: [],
          amount: '',
          currency: ''
        },
      ];
      return { templates: updatedTemplates };
    });
  };

  handleOpen = (open) => {
    this.setState({ open: open });
  };

  handleSave = () => {
    this.props.handleSave(this.state.templates);
  };

  isSaveDisabled = () => {
    return this.state.templates.some((template) => {
      if (!template.name) {
        return true;
      }

      if (!template.source) {
        if (!template.amount || !template.currency) {
          return true;
        }
      }
      if (template.source === 'Ledgers') {
        if (!template.name || !template.category || template.category.length === 0) {
          return true;
        }
      }

      return false;
    });
  };


  render() {
    const { templates } = this.state;
    const { allLedgers } = this.props;


    const renderSection = (sectionName) => (
      <>
        <h4 style={{ marginLeft: '24px', marginTop: '24px' }}>{sectionName}</h4>
        <div
          style={{
            display: 'flex',
            justifyContent: 'left',
            marginTop: '16px',
            marginLeft: '24px',
            marginRight: '24px',
          }}
        >
          <div className="transaction-form-section">
            {templates
              .filter((template) => template.section === sectionName)
              .map((template, index) => (
                <SettingRow
                  key={index}
                  index={index}
                  template={template}
                  allLedgers={allLedgers}
                  handleTemplateChange={this.handleTemplateChange}
                  removeTemplateRow={this.removeTemplateRow}
                  draggedIndex={this.state.draggedIndex}
                  onDragStart={this.onDragStart}
                  onDragOver={this.onDragOver}
                  onDragEnd={this.onDragEnd}
                  anchorEl={this.state.anchorEl}
                  sectionName={sectionName}
                />
              ))}
            <div style={{ marginTop: '30px' }}>
              <IconButton onClick={() => this.addTemplateRow(sectionName)}>
                <AddCircleIcon fontSize="small" color="secondary" />
              </IconButton>
            </div>
          </div>
        </div>
        <Divider style={{ marginLeft: '16px', marginRight: '16px', width: '98%' }} />
      </>
    );

    return (
      <React.Fragment>
        <TopToolbar
          pageName={`Balance Sheet Settings (${this.props.selectedYear})`}
          menuItems={[
            {
              title: BACK,
              icon: <KeyboardBackspaceIcon />,
              onClick: () => {
                this.props.setCurrentPage(BALANCE_SHEET_PAGES.TABLE, {});
              },
            },
            {
              title: 'Save',
              icon: <SaveIcon />,
              onClick: this.handleSave,
              disabled: this.isSaveDisabled(),
            },
          ].filter(Boolean)}
        />

        {renderSection('Assets')}
        {renderSection('Liabilities')}
        {renderSection('Equity')}

      </React.Fragment>
    );
  }
}

const SettingRow = React.memo(
  ({
    index,
    template,
    allLedgers,
    handleTemplateChange,
    removeTemplateRow,
     draggedIndex, onDragStart, onDragOver, onDragEnd, sectionName
  }) => {

    const formatBalance = (balance) => {
      const validBalance = parseFloat(balance);
      if (isNaN(validBalance)) {
        return '0.00';
      }
      return validBalance
        .toFixed(2)
        .toString()
        .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }

    const onBlurHandle = (name, value) => {
      const formattedValue= formatBalance(value);
      handleTemplateChange({ target: { name: "amount", value: formattedValue } }, index, sectionName)
    };

    const displayNameEditingTextField = () => {
      return <TextField
        style={{marginLeft:"-8px",padding:"0"}}
        className="full-width-source-statement"
        variant="outlined"
        name="name"
        label="Name"
        InputLabelProps={{ shrink: true }}
        value={template.name || ""}
        onChange={(e) => handleTemplateChange({ target: { name: "name", value: e.target.value } }, index,sectionName)}
        required
        error={!template.name}
      />
    }

    const displaySourceEditingDropdown = () => {
        return (
          <Autocomplete
            className="full-width-source-statement"
            options={INCOME_SOURCE_OPTIONS}
            getOptionLabel={(option) => option}
            value={template.source || null}
            onChange={(e, value) => handleTemplateChange({
              target: { name: "source", value: value } }, index, sectionName)
            }
            renderInput={(params) =>
              <TextField
                {...params}
                name="source"
                label="Source"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            }
          />
        );
    }

    const displayCategoryEditingDropdown = () => {

        if (template.source === 'Ledgers') {
          return (
            <div>
              <Autocomplete
                className="full-width-ledger-category"
                multiple
                value={
                  Array.isArray(template.category)
                    ? template.category
                      .map(
                        (cat) =>
                          allLedgers.find(
                            (ledger) => ledger.name === cat
                          )
                      )
                      .filter(Boolean)
                    : []
                }
                options={(allLedgers || [])
                  .filter(
                    (ledger) =>
                      [sectionName].includes(ledger.type) &&
                      ledger.isShowTrialBalance === true
                  )
                  .sort((a, b) => a.displayOrder - b.displayOrder)}
                getOptionLabel={(option) => option.name || ''}
                autoHighlight={true}
                renderTags={(value) => {
                  return value.map((option) => (
                    <Chip
                      key={option.name}
                      variant="outlined"
                      size="small"
                      style={{
                        borderColor: '#acd685',
                        margin: '1px 6px 1px 0',
                        fontSize: '12px',
                      }}
                      label={option.name}
                    />
                  ));
                }}
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.name}
                  </React.Fragment>
                )}
                name="category"

                onChange={(e, value) =>
                  handleTemplateChange({
                    target: { name: "category", value: value.map((cat) => cat?.name) },
                  }, index, sectionName)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Ledgers"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    name="category"
                    required
                    error={!template.category}
                  />
                )}
              />
            </div>
          )
        }else if (template.source === 'Income Statement') {
          return (
            <div>
              <Autocomplete
                className="full-width-ledger-category"
                multiple
                // Map the string "Net Income" back to an object for the Autocomplete value
                value={(template.category || []).map((name) => ({ name }))}
                // Only one option available
                options={[{ name: 'Net Income' }]}
                getOptionLabel={(option) => option.name || ''}
                autoHighlight={true}
                renderTags={(value) =>
                  value.map((option) => (
                    <Chip
                      key={option.name}
                      variant="outlined"
                      size="small"
                      style={{
                        borderColor: '#acd685',
                        margin: '1px 6px 1px 0',
                        fontSize: '12px',
                      }}
                      label={option.name}
                    />
                  ))
                }
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.name}
                  </React.Fragment>
                )}
                name="category"
                onChange={(e, value) =>
                  handleTemplateChange(
                    {
                      target: { name: 'category', value: value.map((cat) => cat?.name) },
                    },
                    index,
                    sectionName
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Source Option"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    name="category"
                    required
                    error={!template.category || template.category.length === 0}
                  />
                )}
              />
            </div>
          );
        }

    }

    const displayBalanceEditingTextField = () => {
      if(!template.source){
        return (

          <div  className="full-width-ledger-category">
            <div   style={{marginRight:'10px', width:'150px'}}>
              <Autocomplete
                options={INCOME_CURRENCY_OPTIONS}
                getOptionLabel={(option) => option}
                value={template.currency || null}
                onChange={(e, value) => handleTemplateChange({
                  target: { name: "currency", value: value } }, index, sectionName)
                }
                renderInput={(params) =>
                  <TextField
                    {...params}
                    name="currency"
                    label="Currency"
                    variant="outlined"
                    required
                    InputLabelProps={{ shrink: true }}
                  />
                }
              />
            </div>


            <div     style={{ width:'150px'}}>
              <TextField
                required
                variant="outlined"
                name="amount"
                label="Amount"
                value={template.amount || ''}
                InputLabelProps={{ shrink: true }}
                onBlur={(e) => onBlurHandle(e.target.name, e.target.value)}
                onChange={(e) => handleTemplateChange({ target: { name: "amount", value: e.target.value } }, index, sectionName)}
              />
            </div>


          </div>

        );
      }
      return null

    };


    return (
      <div className="transaction-form-details"
           draggable
           onDragStart={() => onDragStart(index,sectionName)}
           onDragOver={(e) => {
             e.preventDefault();
             onDragOver(index, sectionName);
           }}
           onDragEnd={() => onDragEnd(sectionName)}
      >

        <div style={{ width: '4.5%', height: '60px', display: 'flex' }}>
          <IconButton onClick={() => removeTemplateRow(index,sectionName)}>
            <RemoveCircleIcon fontSize="small" color="error" />
          </IconButton>
        </div>

        <div className="rowSpecLedger full-width-name">

          {displayNameEditingTextField()}
          {displaySourceEditingDropdown()}
          {displayCategoryEditingDropdown()}
          {displayBalanceEditingTextField()}
          <MenuIcon
            style={{
              marginTop: '-10px',
              cursor: 'grab',
              opacity: '0.6',
              alignSelf: 'center',
            }}
          />
        </div>
      </div>
    );
  }
  )
;


export default BalanceSheetSettings;

